/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCurrentPrices} from '../api'

 export const useQueryGetCurrentPrices = createReactQueryHook('getCurrentPrices', getCurrentPrices)
